import { Col, Row } from "antd";
import { useEffect, useState, type FC } from "react";
import type { MetadataType } from "./MetadataType";

function handleGoogleSearch(query) {
    return `https://www.google.com/search?q=${encodeURIComponent(query)}`;
}

const Metadata: FC<MetadataType> = ({ displayedValuesWithPositions, metadataInfo }) => {
    const [description, setDescription] = useState("");

    const partNumber = metadataInfo.part_number;
    const manufName = metadataInfo.manuf_name;
    const className = metadataInfo.class_name;

    useEffect(() => {
        setDescription(metadataInfo.description);
    }, [metadataInfo]);

    // useEffect(() => {
    //     setDescription(createDescription());
    // }, [displayedValuesWithPositions]);

    const boldText = (value, v) =>
        value.substr(0, v.from) +
        '<span title="' +
        v.attr +
        '" class="selected" style=background-color:' +
        `${properties.shades.mintGreen}` +
        ">" +
        value.substr(v.from, v.length) +
        "</span>" +
        value.substr(v.from + v.length);

    const checkSelection = (annotation, showed) => {
        function isOverlapping(annotation1, annotation2) {
            return !(
                annotation1.from + annotation1.length < annotation2.from ||
                annotation2.from + annotation2.length < annotation1.from
            );
        }

        for (let i = 0; i < showed.length; i++) {
            if (isOverlapping(annotation, showed[i])) {
                return false;
            }
        }
        return true;
    };

    const createDescription = () => {
        if (displayedValuesWithPositions.length === 0) {
            return metadataInfo.description;
        } else {
            const sorted = [...displayedValuesWithPositions].sort((a, b) => {
                return (a.from + a.length) - (b.from + b.length);
            });
            let value = metadataInfo.description;
            const showed = [];
            for (let i = sorted.length; i > 0; i--) {
                if (checkSelection(sorted[i - 1], showed)) {
                    value = boldText(value, sorted[i - 1]);
                    showed.push(sorted[i - 1]);
                }
            }
            return value;
        }
    };

    return (
        <>
            <Row>
                <Col span={8} >
                    PART NUMBER:{" "}
                    <b>
                        {partNumber === "" || partNumber === "N/A" || partNumber === "NA" ? (
                            "N/A"
                        ) : (
                            <a href={handleGoogleSearch(partNumber)} target="_blank" rel="noopener noreferrer">
                                {partNumber}
                            </a>
                        )}
                    </b>
                </Col>
                <Col span={8} >
                    MANUFACTURE NAME:{" "}
                    <b>
                        {manufName === "" || manufName === "N/A" || manufName === "NA" ? (
                            "N/A"
                        ) : (
                            <a href={handleGoogleSearch(manufName)} target="_blank" rel="noopener noreferrer">
                                {manufName}
                            </a>
                        )}
                    </b>
                </Col>
                <Col span={8} >
                    CLASS NAME: <b>{className === "" || className === "N/A" || className === "NA" ? "N/A" : className}</b>
                </Col>
            </Row>

            <p>  DESCRIPTION:
                <div dangerouslySetInnerHTML={{ __html: description }} />
            </p>
        </>
    );
}

export default Metadata;


